import React from 'react';
import { H3, StackedColumn, StackedColumnSpacing } from '../../../core';
import { ReminderInstruction } from '../../../api/models';
import Instruction from './instruction/Instruction';

interface InstructionsProps {
  reminderInstructions: ReminderInstruction[];
}

const Instructions: React.FC<InstructionsProps> = (
  props: InstructionsProps
) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      {props.reminderInstructions ? (
        <StackedColumn spacing={StackedColumnSpacing.NoGap}>
          <H3 text="INSTRUCTIONS" />
          <StackedColumn>
            {props.reminderInstructions.map((instruction) => (
              <Instruction
                key={instruction.title}
                reminderInstruction={instruction}
              />
            ))}
          </StackedColumn>
        </StackedColumn>
      ) : null}
    </StackedColumn>
  );
};

export default Instructions;
